
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web-development",
      function () {
        return require("private-next-pages/web-development/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web-development"])
      });
    }
  